<template>
  <section>
    <section v-if="!showSearchResults" id="userIndex">
      <v-row justify="space-between" align="center">
        <v-col cols="5" md="auto">
          <h2
            :class="[
              isMobile ? 'h5' : 'h4',
              isMobile && isDark ? 'white--text' : 'primary--text',
            ]"
            style="word-break: normal"
          >
            Historial de Evaluaciones
          </h2>
        </v-col>
        <v-col cols="auto" class="py-0" v-if="user !== 'agent'">
          <v-switch
            class="ml-auto"
            v-model="activeGraph"
            inset
            label="Ver gráficas"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row justify="space-between" class="align-center">
        <v-col cols="auto">
          <v-chip-group mandatory v-model="approvedStatus" active-class="success">
            <span class="caption my-auto">Filtrar:</span>
            <!-- <v-chip class="mx-1" label :value="0">
              Todos
            </v-chip> -->
            <v-chip class="mx-1" label :value="1">
              Aprobadas
            </v-chip>

            <v-chip class="mx-1" label :value="0">
              Reprobadas
            </v-chip>
            <v-chip class="mx-1" label :value="2">
              Nuevos
            </v-chip>
          </v-chip-group>
        </v-col>
        <v-col cols="12" md="auto">
          <v-text-field
            filled
            rounded
            dense
            :readonly="ShowSearchModule"
            @click="openSearchDialog"
            v-model="searchQuery"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-card class="shadow-1 mt-5">
        <v-card flat v-if="approvedStatus < 2">
          <!-- Tabla -->
          <v-container v-show="!activeGraph">
            <vuescroll
              :ops="{
                bar: {
                  background: '#bacfcec0',
                  keepShow: true,
                },
              }"
            >
              <v-data-table
                :headers="evaluationHeaders"
                :items="evaluationData"
                class="elevation-0"
                :search="ShowSearchModule ? searchQuery : undefined"
                :loading="isLoading"
                :options.sync="options"
                :server-items-length="totalItems"
                :footer-props="{
                  'items-per-page-options': [50, 100],
                }"
              >
                <template v-slot:[`item.date`]="{ item }">
                  <span class="d-inline pr-2">
                    {{ normalizeDate(item.date) }}
                  </span>
                </template>
                <template v-slot:[`item.average`]="{ item }">
                  <span class="d-inline pr-2">
                    {{ getAverage(item) }}
                  </span>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-hover v-slot:default="{ hover }">
                    <v-btn
                      text
                      icon
                      :color="hover ? 'accent' : 'blue-grey'"
                      @click.stop="goToReport(item.id)"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </v-hover>
                </template>
              </v-data-table>
            </vuescroll>
          </v-container>

          <!-- Gráficas -->
          <v-container v-if="activeGraph" fluid>
            <v-row align="center" justify="center">
              <v-col cols="12" md="5" v-if="render">
                <v-card outlined>
                  <v-card-text>
                    <apexchart
                      ref="chart5"
                      type="donut"
                      :options="optionsDonut"
                      :series="donutSeries"
                    ></apexchart>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col v-else-if="!render" cols="12" md="5">
                <v-skeleton-loader
                  transition="scale-transition"
                  class="mx-auto"
                  type="card"
                >
                </v-skeleton-loader>
              </v-col>

              <v-col v-if="render" cols="12" md="6">
                <v-card outlined>
                  <!-- <v-card-title
                  class="title text--primary"
                  style="word-break: normal; line-height: normal"
                >
                  Llamadas entrantes por extensión
                </v-card-title> -->
                  <v-card-text>
                    <apexchart
                      ref="chart7"
                      type="bar"
                      :options="optionsBar"
                      :series="barSeries"
                    ></apexchart>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col v-else cols="12" md="6">
                <v-skeleton-loader
                  transition="scale-transition"
                  class="mx-auto"
                  type="card"
                >
                </v-skeleton-loader>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card flat v-else>
          <!-- Tabla -->
          <v-container v-show="!activeGraph">
            <vuescroll
              :ops="{
                bar: {
                  background: '#bacfcec0',
                  keepShow: true,
                },
              }"
            >
              <v-data-table
                :headers="newReportsHeaders"
                :items="evaluationData"
                class="elevation-0"
                :search="ShowSearchModule ? searchQuery : undefined"
                :loading="isLoading"
                :options.sync="options"
                :server-items-length="totalItems"
                :footer-props="{
                  'items-per-page-options': [50, 100],
                }"
              >
                <template v-slot:[`item.date`]="{ item }">
                  <span class="d-inline pr-2">
                    {{ normalizeDate(item.date) }}
                  </span>
                </template>
                <template v-slot:[`item.average`]="{ item }">
                  <span class="d-inline pr-2">
                    {{ getAverage(item) }}
                  </span>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-hover v-slot:default="{ hover }">
                    <v-btn
                      text
                      icon
                      :color="hover ? 'accent' : 'blue-grey'"
                      @click.stop="viewResults(item)"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </v-hover>
                </template>
              </v-data-table>
            </vuescroll>
          </v-container>

          <!-- Gráficas -->
          <v-container v-if="activeGraph" fluid>
            <v-row align="center" justify="center">
              <v-col cols="12" md="5" v-if="render">
                <v-card outlined>
                  <v-card-text>
                    <apexchart
                      ref="chart5"
                      type="donut"
                      :options="optionsDonut"
                      :series="donutSeries"
                    ></apexchart>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col v-else-if="!render" cols="12" md="5">
                <v-skeleton-loader
                  transition="scale-transition"
                  class="mx-auto"
                  type="card"
                >
                </v-skeleton-loader>
              </v-col>

              <v-col v-if="render" cols="12" md="6">
                <v-card outlined>
                  <!-- <v-card-title
                  class="title text--primary"
                  style="word-break: normal; line-height: normal"
                >
                  Llamadas entrantes por extensión
                </v-card-title> -->
                  <v-card-text>
                    <apexchart
                      ref="chart7"
                      type="bar"
                      :options="optionsBar"
                      :series="barSeries"
                    ></apexchart>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col v-else cols="12" md="6">
                <v-skeleton-loader
                  transition="scale-transition"
                  class="mx-auto"
                  type="card"
                >
                </v-skeleton-loader>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-card>
    </section>

    <search-results
      v-else
      :searchParams="searchParams"
      :searchQuery="searchQuery"
      @action:back="closeSearchResults"
      @click:search="isOpenSearchDialog = true"
    ></search-results>

    <results-dialog
      :isOpen="isOpenResultsDialog"
      :itemToResults="newReportToShow"
      :recordingUrl="newReportsRecordingUrl"
      @dialog:close="closeResults"
    ></results-dialog>

    <search-dialog
      :isActive="isOpenSearchDialog"
      @dialog:close="closeSearchDialog"
    ></search-dialog>
  </section>
</template>

<script>
import axios from "axios";
import moment from "moment";
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import SearchResults from "./SearchResults.vue";
import SearchDialog from "./SearchDialog.vue";
import getSearchString from "../TypificationReport/getSearchString";
import ResultsDialog from "./ResultsDialog.vue";

export default {
  components: { vuescroll, SearchResults, SearchDialog, ResultsDialog },
  props: {
    user: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      isLoading: false,
      isOpenResultsDialog: false,
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 50,
      },
      approvedStatus: 1,
      evaluationData: [],
      newReportToShow: {},
      newReportsRecordingUrl: "",
      evaluationHeaders: [
        { text: "Nombre", value: "name", width: "20%" },
        {
          text: "Fecha",
          value: "date",
          width: "20%",
        },
        {
          text: "# de pruebas",
          value: "cantTest",
          sortable: false,
          width: "20%",
        },
        {
          text: "Promedio total",
          value: "average",
          width: "20%",
        },
        {
          text: "Acciones",
          value: "action",
          width: "20%",
        },
      ],
      newReportsHeaders: [
        {
          text: "Fecha",
          value: "date",
          width: "16%",
        },
        {
          text: "Usuario",
          value: "user",
          width: "10%",
        },
        {
          text: "Extensión",
          value: "extension",
          width: "10%",
        },
        {
          text: "Numero",
          value: "number",
          width: "10%",
        },
        {
          text: "puntaje obtenido",
          value: "value",
          width: "15%",
        },
        {
          text: "Observación",
          value: "observations",
          width: "17%",
        },
        {
          text: "Comentarios del agente",
          value: "agent_comment",
          width: "17%",
        },

        {
          text: "Acciones",
          value: "action",
          width: "15%",
        },
      ],
      agentHeaders: [
        { text: "Nombre", value: "name", width: "45%" },
        {
          text: "Cantidad de evaluaciones",
          value: "date",
          width: "10%",
        },
        {
          text: "Promedio",
          value: "average",
          width: "10%",
        },
      ],
      reportApi: {
        default: `${process.env.VUE_APP_ROOTAPI}/quality/report/evaluation`,
        agent: `${process.env.VUE_APP_ROOTAPI}/report/agent/evaluation_agent`,
      },
      render: false,
      searchQuery: "",
      searchParams: {},
      showSearchResults: false,
      isOpenSearchDialog: false,
      activeGraph: false,
      evaluationToShow: null,
      mainSection: true,
      // currentPage: null,
      // pageCount: null,
      // totalPages: 1,
      optionsDonut: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },
        dataLabels: { enabled: false },
        labels: [],
      },
      optionsBar: {
        xaxis: {
          categories: [],
        },
        fill: {
          colors: ["#6D71F9"],
        },
      },
    };
  },

  created() {
    this.getRecordingUrl();
  },

  watch: {
    options: {
      handler() {
        this.getReports();
      },
      deep: true,
    },
    approvedStatus() {
      if (this.options.page !== 1) this.options.page = 1;
      else this.getReports();
    },
  },

  //   created() {
  //     this.getReports();
  //   },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    User() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
    AgentList() {
      return this.$store.getters["agents/GET_ALL_AGENTS"];
    },
    ShowSearchModule() {
      return [1, 2].includes(this.User.role_id);
    },
    isDark() {
      return this.$vuetify.theme.dark;
    },
    donutSeries() {
      return this.evaluationData.map((el) => el.cantTest);
    },
    barSeries() {
      return [{ name: "Cantidad", data: this.donutSeries }];
    },
  },

  methods: {
    // handlePageChange(value) {
    //     this.currentPage = value;
    //     this.getReports();
    // },
    openSearchDialog() {
      if (this.ShowSearchModule) this.isOpenSearchDialog = true;
    },
    closeSearchDialog(searchParams) {
      this.isOpenSearchDialog = false;
      if (!searchParams) {
        this.closeSearchResults();
        return;
      }
      this.searchParams = searchParams;

      const userName = searchParams.userId
        ? this.AgentList.find((agent) => agent.id === searchParams.userId)?.name
        : undefined;

      this.searchQuery = getSearchString({ ...searchParams, userId: userName });
      this.showSearchResults = true;
    },
    closeSearchResults() {
      this.searchParams = {};
      this.searchQuery = "";
      this.showSearchResults = false;
    },
    normalizeDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },

    getAverage(item) {
      if (!item || !item.test || !item.test[0]) return "0";

      const cantTest = Number(item.cantTest);
      const sumTest = Number(item.test[0].sumtest);

      if (cantTest > 0 && !isNaN(sumTest)) {
        return (sumTest / cantTest).toFixed(2);
      }

      return "0";
    },

    goToReport(id) {
      return this.user === "default"
        ? this.$router.push(`/reporte-pruebas/${id}`)
        : this.$router.push(`/test-report/agent/${this.approvedStatus}/${id}`);
    },
    async getReports() {
      this.isLoading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const accessToken = localStorage.getItem("token");
      try {
        let res;
        if (this.approvedStatus === 2)
          res = await PbxHttpClient.get("/report/agent/test/new", {
            params: { page, itemPerPage: itemsPerPage },
          });
        else
          res = await axios.get(`${this.reportApi[this.user]}`, {
            headers: { Authorization: `Bearer ${accessToken}` },
            params: {
              page,
              approved_status: this.approvedStatus,
              itemPerPage: itemsPerPage,
            },
          });

        this.evaluationData = res.data.data;
        this.totalItems = res.data.total;
        
        // this.totalPages = res.data.last_page;
        this.optionsDonut.labels = res.data.data.map((el) => el.name);
        this.optionsBar.xaxis.categories = res.data.data.map((el) => el.name);
        // console.log(res);
      } catch (error) {
        // console.log(error.response);
        if (error.response.status === 401) {
          this.$snotify.error("Su sesion ha finalizado.", "Error");
          this.$store.dispatch("passport/RESET_AUTH");
          this.$router.push({ name: "login" });
          return;
        }
        // console.error(error);
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      }
      this.render = true;
      this.isLoading = false;
    },
    async getRecordingUrl() {
      this.isLoading = true;
      const accessToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_ROOTAPI}/url_client`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        this.newReportsRecordingUrl = data.url;
        // console.log("URL", data);
      } catch (err) {
        console.log(err);
      }
      this.isLoading = false;
    },
    async viewResults(item) {
      await this.getTest(item.id);

      this.isOpenResultsDialog = true;
    },
    closeResults() {
      this.newReportToShow = {};
      this.isOpenResultsDialog = false;
    },
    async getTest(id) {
      try {
        const { data } = await PbxHttpClient.get(`/quality/test/${id}`);
        this.newReportToShow = data.data;
      } catch (err) {
        console.log("error getting the report", err);
      }
    },
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
    0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
}
</style>
